import { action } from 'satcheljs';
/**
 * Action to propagate the flag items action to client stores
 * @param itemContexts - the contexts for items being acted on
 * @param flagStatusToSet - the flag status to set on the items
 * @param parentFolderId - the parent FolderId
 */
export default action('FLAG_ITEMS_STORE_UPDATE', function (itemContexts, flagStatusToSet, parentFolderId) {
    return {
        itemContexts: itemContexts,
        flagStatusToSet: flagStatusToSet,
        parentFolderId: parentFolderId,
    };
});
//# sourceMappingURL=flagItemsStoreUpdate.js.map